


import { Component, Prop, Vue } from 'vue-facing-decorator';
import ToggleButton from './ToggleButton.vue';
import { Vue3SlideUpDown } from "vue3-slide-up-down";
import ChevronIcon from '../icons/ChevronIcon.vue'


// import {Purpose} from '@iabtechlabtcf/core'

// Purpose type not exported (WTF???) so we have to define it here

type Purpose = {
  id: number;
  name: string;
  description: string;
  descriptionLegal?: string;
  illustrations?: string[];
};


@Component({
  components: {
    ToggleButton,
    Vue3SlideUpDown,
    ChevronIcon
  },
})

export default class SpecialPurposeItem extends Vue {

    consent = false;
    legitInterest = false;

    expanded = false;
    collapseClass = "collapseButton collapseButtonRotatedUp"

    formattedDescriptions :string[] = [];
    formattedCanNotDescriptions :string[] = [];
    introDescription :string = "Our partners may:";

    @Prop( { default:{ name:'none', id:0 } }) purpose!: Purpose;

    mounted() : void {

      
      let parts = this.purpose?.descriptionLegal?.split("Vendors cannot:")

      if (parts && parts.length) {
        let s = parts[0].replace("Vendors can:", "")
        s = s.replace(/(\r\n|\n|\r)/gm, "")
        s = s.replace("N.B. ", " ")

        this.formattedDescriptions = s.split("* ").filter( ( e : any ) => Boolean((<String>e).length) );
        
        if ( this.formattedDescriptions.length ) {
          this.introDescription = <string> this.formattedDescriptions.shift(); // remove and return first element
        }

        if (parts.length > 1) {
          let s = parts[1].replace(/(\r\n|\n|\r)/gm, "");
          s = s.replace("N.B. ", " ");

          this.formattedCanNotDescriptions = s.split("* ").filter( ( e : any ) => Boolean((<String>e).length) );
          }
      
      }
    }

    expandCollapseClick() {
      if ( ! this.expanded )
        this.collapseClass = 'collapseButton collapseButtonRotatedDown';
      else
        this.collapseClass = 'collapseButton collapseButtonRotatedUp';

      this.expanded = ! this.expanded;
    }

}

